import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'money',
  standalone: true
})
export class MoneyPipe implements PipeTransform {
  transform(value: any, precision: number = 2, currency: string | null = null): unknown {
    if (currency === null || currency.length != 3) {
      currency = 'EUR';
    }

    let input = parseFloat(value) / 100;

    if (isNaN(input)) {
      return value;
    }

    precision = precision || 2;

    return Intl.NumberFormat('fr-FR', {
      maximumFractionDigits: precision,
      minimumFractionDigits: precision,
      style: 'currency',
      currency: currency,
      currencyDisplay: 'narrowSymbol'
    }).format(input);
  }
}
